module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/data-second-bg.de2e6b43.png";